


























import { lazyInject } from '@/container'
import { TYPES } from '@/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CyclingAds extends Vue {
  @Prop(Array) adsForSlides!: Array<any>

  @lazyInject(TYPES.AdService)
  AdService: any

  handleSlideEnd (slide: any) {
    let id = this.adsForSlides[slide].id
    let action = 'impression'

    this.AdService.performAction(id, action)
      .then((response: any) => {
        // console.log(response)
      })
      .catch((error: any) => {
        console.error(`Ad impression tracking error ${error}`)
      })
  }

  handleClick (ad: any) {
    let action = 'click'

    this.AdService.performAction(ad.id, action)
      .then((response: any) => {
        // console.log(response)
      })
      .catch((error: any) => {
        console.error(`Ad click tracking error ${error}`)
      })

    window.open(ad.url, '_blank')
  }
}
